import { render, staticRenderFns } from "./OverworldScreen.vue?vue&type=template&id=c5cd46c2&scoped=true"
import script from "./OverworldScreen.vue?vue&type=script&lang=js"
export * from "./OverworldScreen.vue?vue&type=script&lang=js"
import style0 from "./OverworldScreen.vue?vue&type=style&index=0&id=c5cd46c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cd46c2",
  null
  
)

export default component.exports